import httpClient from "@/services/httpClient";
import {
    server, trademark_const
} from "@/services/constants";

export const getAllCountry = () => {
    return httpClient.get(`${trademark_const.trademark_url}/` + server.COUNTRY + `/getAll`);
};